import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getMatchingData } from '../../../Firebase/CloudFirestore/GetData'
import { changeDateFormate } from '../../../Utils/Utils'
import moment from 'moment'

export default function EducationDetails({ activeTab, setLoader }) {
    let { id } = useParams()
    const [allEducation, setAllEducation] = useState([])


    async function getProfetionalData() {
        setLoader(true)
        try {
            let [res] = await getMatchingData('professionalDetails', 'userId', '==', id)
            if (res !== undefined) {
                setAllEducation(res?.educations)
            }
        } catch (err) {
            console.log(err)
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {
        if (activeTab === '1') {
            getProfetionalData()
        }
    }, [activeTab])



    return (
        <>
            <div>
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='fs-5 fw-600 text-secondary'>Education</div>
                    {/* <button className='btn btn-sm btn-primary' onClick={() => setOpenAddModal(true)}>Add Document</button> */}
                </div>
                <div className={` mt-4`}>
                    {allEducation?.map((res, index) => (
                        <>
                            <div key={index} className='border rounded p-3 mt-3'>
                                <div className='d-flex flex-md-row flex-sm-row flex-column justify-content-md-between justify-content-sm-between justify-content-start'>
                                    <div className='fw-bold text-secondary text-capitalize'>{res?.degree}</div>
                                    <div className='f-14 text-gray'>{moment(changeDateFormate(res?.startDate))?.format('YYYY')} - {moment(changeDateFormate(res?.endDate))?.format('YYYY')}</div>
                                </div>
                                <div className='f-14 text-gray mt-2 text-capitalize'>{res?.university}</div>
                                <div className='f-14 text-gray mt-2'>{res?.grade == ''?'':res?.grade}</div>
                            </div>
                        </>
                    ))}
        
                </div>
            </div>
        </>
    )
}
